export default __webpack_public_path__ + "static/media/home.7102f076.svg";